import { Component, OnInit,ViewChild,ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';
import { PaymentSandbox } from '../../../../../../core/payment/payment.sandbox';
import { ActivatedRoute, Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import {CommisionService} from '../../../../../../core/commission/commison.service';


@Component({
  selector: 'app-commisions',
  templateUrl: './commisions.component.html',
  styleUrls: ['./commisions.component.scss']
})
export class CommisionsComponent implements OnInit {
  public filterForm: FormGroup;
  public filter = false;
  public miniDate: any;
  public dateError: string;
  public startDate: any;
  public isRequired = false;
  public endDate: any;
  @ViewChild(NgbDropdown)
  public dropdown: NgbDropdown;
  public keyword = '';
  public earningsArray = [];
  public filterData: any = [];
  public filterDataId = [];
  public selectedAll: any;
  public limit = 10;
  public offset = 0;
  public currentPage = 1;
  public userDetails = JSON.parse(sessionStorage.getItem('vendor-settings'));
  public currencyCode ;
  public queryData: any = {};
  public CommissionData 
  // = [{"vendorPaymentId":323,"vendorOrderId":440,"subOrderId":"SPU-2023051544824","customerFirstName":"Safety","orderId":448,"shippingCity":"LOS ANGELES","shippingCountry":"United States","shippingZone":"CA","currencyCode":"USD","currencySymbolLeft":"$","currencySymbolRight":null,"createdDate":"2023-05-15T05:45:51.000Z","amount":9,"commissionAmount":"1.41","orderStatusName":"Processing","orderStatusColorCode":"#6798e3","makeSettlement":0,"commission":8,"adminCommission":"0.72","gatewayCommission":"0.28","orderProductPrefixId":"SPU-20230515448","tax":"0.9200","shippingCharge":"4.13","total":"14.05","totalCommission":1,"NetAmount":"14.05","sallerAmount":8.920000000000002},{"vendorPaymentId":322,"vendorOrderId":439,"subOrderId":"SPU-2023051244724","customerFirstName":"Safety","orderId":447,"shippingCity":"LOS ANGELES","shippingCountry":"United States","shippingZone":"CA","currencyCode":"USD","currencySymbolLeft":"$","currencySymbolRight":null,"createdDate":"2023-05-12T12:47:22.000Z","amount":42,"commissionAmount":"5.72","orderStatusName":"Refunded","orderStatusColorCode":"#501328","makeSettlement":0,"commission":8,"adminCommission":"3.36","gatewayCommission":"1.14","orderProductPrefixId":"SPU-20230512447","tax":"4.3100","shippingCharge":"0.78","total":"47.09","totalCommission":4.5,"NetAmount":"47.09","sallerAmount":41.81},{"vendorPaymentId":321,"vendorOrderId":438,"subOrderId":"SPU-2023051244624","customerFirstName":"sam","orderId":446,"shippingCity":"LOS ANGELES","shippingCountry":"United States","shippingZone":"CA","currencyCode":"USD","currencySymbolLeft":"$","currencySymbolRight":null,"createdDate":"2023-05-12T12:45:37.000Z","amount":35,"commissionAmount":"4.94","orderStatusName":"Refunded","orderStatusColorCode":"#501328","makeSettlement":0,"commission":8,"adminCommission":"2.80","gatewayCommission":"0.99","orderProductPrefixId":"SPU-20230512446","tax":"3.5900","shippingCharge":"10.85","total":"49.44","totalCommission":3.79,"NetAmount":"49.44","sallerAmount":34.8},{"vendorPaymentId":320,"vendorOrderId":437,"subOrderId":"SPU-2023051244524","customerFirstName":"lock","orderId":445,"shippingCity":"jersey","shippingCountry":"United States","shippingZone":"NJ","currencyCode":"USD","currencySymbolLeft":"$","currencySymbolRight":null,"createdDate":"2023-05-12T12:42:31.000Z","amount":0,"commissionAmount":"0.75","orderStatusName":"delivered","orderStatusColorCode":"#501332","makeSettlement":0,"commission":10,"adminCommission":"0.00","gatewayCommission":"0.15","orderProductPrefixId":"SPU-20230512445","tax":"0.4600","shippingCharge":"7.00","total":"7.46","totalCommission":0.15,"NetAmount":"7.46","sallerAmount":0.30999999999999994},{"vendorPaymentId":319,"vendorOrderId":436,"subOrderId":"SPU-20230512444241","customerFirstName":"Safety","orderId":444,"shippingCity":"ARVADA","shippingCountry":"United States","shippingZone":"CO","currencyCode":"USD","currencySymbolLeft":"$","currencySymbolRight":"","createdDate":"2023-05-12T12:41:45.000Z","amount":69,"commissionAmount":"8.24","orderStatusName":"Refunded","orderStatusColorCode":"#501328","makeSettlement":0,"commission":8,"adminCommission":"5.52","gatewayCommission":"1.65","orderProductPrefixId":"SPU-202305124441","tax":"3.2800","shippingCharge":"10.07","total":"82.35","totalCommission":7.17,"NetAmount":"82.35","sallerAmount":65.11},{"vendorPaymentId":318,"vendorOrderId":435,"subOrderId":"SPU-20230512443241","customerFirstName":"Safety","orderId":443,"shippingCity":"ARVADA","shippingCountry":"United States","shippingZone":"CO","currencyCode":"USD","currencySymbolLeft":"$","currencySymbolRight":"","createdDate":"2023-05-12T12:41:25.000Z","amount":22.999999999999996,"commissionAmount":"3.42","orderStatusName":"packing in progress","orderStatusColorCode":"#f71d1d","makeSettlement":0,"commission":8,"adminCommission":"1.84","gatewayCommission":"0.68","orderProductPrefixId":"SPU-202305124431","tax":"1.0900","shippingCharge":"10.07","total":"34.16","totalCommission":2.52,"NetAmount":"34.16","sallerAmount":21.569999999999997},{"vendorPaymentId":317,"vendorOrderId":434,"subOrderId":"SPU-20230512442241","customerFirstName":"sam","orderId":442,"shippingCity":"LOS ANGELES","shippingCountry":"United States","shippingZone":"CA","currencyCode":"USD","currencySymbolLeft":"$","currencySymbolRight":"","createdDate":"2023-05-12T11:43:30.000Z","amount":102,"commissionAmount":"12.33","orderStatusName":"Processing","orderStatusColorCode":"#6798e3","makeSettlement":0,"commission":8,"adminCommission":"8.16","gatewayCommission":"2.47","orderProductPrefixId":"SPU-202305124421","tax":"10.4600","shippingCharge":"10.85","total":"123.31","totalCommission":10.63,"NetAmount":"123.31","sallerAmount":101.83000000000001},{"vendorPaymentId":316,"vendorOrderId":433,"subOrderId":"SPU-20230512441241","customerFirstName":"sam","orderId":441,"shippingCity":"LOS ANGELES","shippingCountry":"United States","shippingZone":"CA","currencyCode":"USD","currencySymbolLeft":"$","currencySymbolRight":"","createdDate":"2023-05-12T11:43:29.000Z","amount":102,"commissionAmount":"12.33","orderStatusName":"Processing","orderStatusColorCode":"#6798e3","makeSettlement":0,"commission":8,"adminCommission":"8.16","gatewayCommission":"2.47","orderProductPrefixId":"SPU-202305124411","tax":"10.4600","shippingCharge":"10.85","total":"123.31","totalCommission":10.63,"NetAmount":"123.31","sallerAmount":101.83000000000001},{"vendorPaymentId":315,"vendorOrderId":432,"subOrderId":"SPU-20230512440241","customerFirstName":"safety","orderId":440,"shippingCity":"ARVADA","shippingCountry":"United States","shippingZone":"CO","currencyCode":"USD","currencySymbolLeft":"$","currencySymbolRight":"","createdDate":"2023-05-12T11:24:58.000Z","amount":30.999999999999996,"commissionAmount":"3.64","orderStatusName":"shipped","orderStatusColorCode":"#4c7499","makeSettlement":0,"commission":8,"adminCommission":"2.48","gatewayCommission":"0.73","orderProductPrefixId":"SPU-202305124401","tax":"1.4700","shippingCharge":"3.97","total":"36.44","totalCommission":3.21,"NetAmount":"36.44","sallerAmount":29.259999999999998},{"vendorPaymentId":314,"vendorOrderId":431,"subOrderId":"SPU-20230512439241","customerFirstName":"sam","orderId":439,"shippingCity":"LOS ANGELES","shippingCountry":"United States","shippingZone":"CA","currencyCode":"USD","currencySymbolLeft":"$","currencySymbolRight":"","createdDate":"2023-05-12T10:54:07.000Z","amount":6,"commissionAmount":"1.75","orderStatusName":"Processing","orderStatusColorCode":"#6798e3","makeSettlement":0,"commission":8,"adminCommission":"0.48","gatewayCommission":"0.35","orderProductPrefixId":"SPU-202305124391","tax":"0.6200","shippingCharge":"10.85","total":"17.47","totalCommission":0.83,"NetAmount":"17.47","sallerAmount":5.789999999999999}]
  public totalCount
  //  = this.CommissionData.length

  constructor(public paymentSandbox: PaymentSandbox,
    public formbuilder: FormBuilder, 
    public router: Router, 
    public route: ActivatedRoute,
    public titleService:Title,
    private ref : ChangeDetectorRef,
    public service : CommisionService) { }

  ngOnInit(): void {
   
    this.commissionList()
    this.commissionCount()
  }
  // commisionCount() {
  //   this.service.commisionCount().subscribe((data : any) =>{

  //   } )

  // }
  commissionList() {
    let params = {
      limit : this.limit,
      offset : this.offset ,
      orderIds : []
    }

    this.service.CommissionList(params).subscribe((data :any) => {
      if(data) {
        this.CommissionData = data.data;
        // this.totalCount = data.totalCount;
        this.ref.detectChanges();
      }
    });
  }

  commissionCount() {
    let params = {
      limit : this.limit,
      offset : this.offset ,
      orderIds : [],
      count : true
    }

    this.service.commisionCount(params).subscribe((data :any) => {
      if(data) {
        // this.CommissionData = data.data;
        this.totalCount = data.data;
        this.ref.detectChanges();
      }
    });
  }

  initFilterForm() {
    this.filterForm = this.formbuilder.group({
      fromDate: ['', Validators.required],
      toDate: ['', Validators.required]
    });
  }
  /*View Order Page */
  vieworder(id) {
    this.router.navigate(['sales/manage-orders/view-orders'], { queryParams: { id } });
  }

  applyFilter() {
    if (
      (this.filterForm.controls['toDate'].value === '' ||
        this.filterForm.controls['toDate'].value === null) &&
      this.filterForm.controls['fromDate'].value !== '' &&
      this.filterForm.controls['fromDate'].value !== null
    ) {
      this.isRequired = true;
      return;
    }
    const form = this.filterForm.value.fromDate;
    const to = this.filterForm.value.toDate;
    this.filter = true;
    if (form && form.year) {
      this.startDate = form.year + '-' + form.month + '-' + form.day;
    }
    if (to && to.year) {
      this.endDate = to.year + '-' + to.month + '-' + to.day;
    }
    this.dropdown.close();
    this.getEarningsList();
  }

  onDateSelect(event) {
    event.stopPropogation();
    this.miniDate = event;
    this.dateError = '';
  }

  setMinValue(d) {
    this.isRequired = false;
    if (
      this.filterForm.controls['fromDate'].value === '' ||
      this.filterForm.controls['fromDate'].value === null
    ) {
      this.dateError = 'Choose From Date First';
      return;
    }
    d.toggle();
  }

  close() {
    this.dropdown.close();
  }

  resetFilter() {
    this.startDate = '';
    this.endDate = '';
    this.filter = false;
    this.filterForm.reset();
    this.getEarningsList();
  }

  getEarningsList() {
    // const params: any = {};
    // params.deliveryList = 1;
    // params.startDate = this.startDate ? this.startDate : '';
    // params.endDate = this.endDate ? this.endDate : '';
    // params.keyword = this.keyword;
    // params.limit = this.limit;
    // params.offset = this.offset;
    // this.paymentSandbox.getCategoryList(params);
  }

  exportEarnings() {
    if (this.filterDataId.length > 0) {
      const params: any = {};
      params.productId = this.filterDataId.toString();
      this.paymentSandbox.multipleEarningExport(params);
      this.paymentSandbox.categoryListLoaded$.subscribe(data => {
        if (data === true) {
          this.paymentSandbox.removeExportSelection('earning');
          this.selectedAll = false;
          this.filterDataId = [];
        }
      });
    } else {
      const params: any = {};
      const vendor = JSON.parse(sessionStorage.getItem('vendorUserDetails'));
      params.vendorId = vendor.vendorId;
      this.paymentSandbox.exportEarning(params);
    }
  }

  search(val) {
    this.keyword = val;
    this.getEarningsList();
    this.getTotalEarningsCount();
  }

  selectAll() {
    for (let i = 0; i < this.earningsArray.length; i++) {
      this.earningsArray[i].selected = this.selectedAll;
    }
    this.filterDataList();
  }

  checkIfAllSelected() {
    this.selectedAll = this.earningsArray.every(function (item: any) {
      return item.selected === true;
    });
    this.filterDataList();
  }

  filterDataList() {
    this.filterData = this.earningsArray.filter(data => {
      if (data.selected === true) {
        return data;
      }
    });
    this.filterDataId = this.filterData.map(obj => obj.productId);
  }

  getTotalEarningsCount() {
    const params: any = {};
    params.deliveryList = 1;
    params.startDate = this.startDate ? this.startDate : '';
    params.endDate = this.endDate ? this.endDate : '';
    params.keyword = this.keyword;
    params.limit = this.limit;
    params.offset = this.offset;
    params.count = 1;
    this.paymentSandbox.getEarningListCount(params);
    this.queryData.offset = this.offset || 0;
    this.queryData.index = this.currentPage || 1;
    this.router.navigate(
      [],
      {
        relativeTo: this.route,
        queryParams: this.queryData,
        queryParamsHandling: 'merge', // remove to replace all query params by provided
      });

  }

  pageChange(event) {
    this.currentPage = event;
    this.offset = this.limit * (event - 1);
    this.commissionList();
  }

}
